export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            <div>
              <h4 className="text-base font-bold text-background-50 mb-4 font-heading">天天影院</h4>
              <p className="text-xs text-background-400 leading-relaxed">
                最新电视剧全集在线观看平台，覆盖国产剧、韩剧、美剧、日剧等全品类资源，每日同步更新，全部剧集一网打尽。
              </p>
            </div>

            <div>
              <h4 className="text-base font-bold text-background-50 mb-4 font-heading">剧集分类</h4>
              <ul className="space-y-2">
                <li><a href="#index" className="text-xs text-background-400 hover:text-primary-400 transition-colors">国产剧全集</a></li>
                <li><a href="#index" className="text-xs text-background-400 hover:text-primary-400 transition-colors">韩剧全集</a></li>
                <li><a href="#index" className="text-xs text-background-400 hover:text-primary-400 transition-colors">美剧全集</a></li>
                <li><a href="#index" className="text-xs text-background-400 hover:text-primary-400 transition-colors">日剧全集</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-base font-bold text-background-50 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-2">
                <li><a href="#ranking" className="text-xs text-background-400 hover:text-primary-400 transition-colors">热播榜单</a></li>
                <li><a href="#updates" className="text-xs text-background-400 hover:text-primary-400 transition-colors">最新动态</a></li>
                <li><a href="#faq" className="text-xs text-background-400 hover:text-primary-400 transition-colors">常见问题</a></li>
                <li><a href="#contact" className="text-xs text-background-400 hover:text-primary-400 transition-colors">联系我们</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-base font-bold text-background-50 mb-4 font-heading">合作伙伴</h4>
              <p className="text-xs text-background-500">暂无合作伙伴信息</p>
            </div>
          </div>

          <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 天天影院。本站内容仅供学习交流，不存储任何视频文件。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors">回到顶部</a>
              <a href="#about" className="text-xs text-background-500 hover:text-primary-400 transition-colors">关于我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}